// extracted by mini-css-extract-plugin
export var callCard = "_ow-0";
export var callMessageButton = "_ow-1";
export var helpIcon = "_ow-3";
export var helpIconContainer = "_ow-4";
export var verticalDivider = "_ow-2";